import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import "./UserDashboard.css"; 

const UserDashboard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            setUserData(docSnap.data());
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        navigate("/login");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  if (loading) {
    return <div className="loading-screen">Loading your dashboard...</div>;
  }

  // --- CHECK FOR PENDING STATUS ---
  if (!userData || userData.status === "in progress" || userData.status === "pending") {
    return (
      <div className="user-dashboard-container">
        <nav className="user-navbar">
          <div className="brand">User <span className="highlight">Portal</span></div>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </nav>
        <div className="dashboard-content">
          <div className="waiting-message-card">
            <div className="waiting-icon">⏳</div>
            <h2>Account Under Review</h2>
            <p>Hi {userData?.name || "there"}, thank you for registering!</p>
            <p>Your account is currently <span className="highlight">in progress</span>. Please wait until the admin approves your account to access your dashboard.</p>
          </div>
        </div>
      </div>
    );
  }

  // --- FORMAT REVENUE ---
  const formatRevenue = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount || 0);
  };

  // --- MAIN DASHBOARD VIEW (If active) ---
  return (
    <div className="user-dashboard-container">
      <nav className="user-navbar">
        <div className="brand">User <span className="highlight">Portal</span></div>
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </nav>

      <div className="dashboard-content">
        <header className="dashboard-header">
          <h1>👋 Welcome back, <span className="highlight">{userData?.name || "User"}</span>!</h1>
          <p>Here is your personalized overview.</p>
        </header>

        <section className="stats-grid">
          {/* 1. Revenue Card */}
          <div className="stat-card revenue-card">
            <h3>Total Revenue</h3>
            <p className="revenue-value">{formatRevenue(userData.revenue)}</p>
          </div>
          
          {/* 2. Status Card */}
          <div className="stat-card status-card">
            <h3>Account Status</h3>
            <p className={`status ${userData.status}`}>
              {userData.status}
            </p>
          </div>

          {/* 3. Combined Project & Hosting Card */}
          <div className="stat-card project-hosting-card">
            <h3>Project & Hosting</h3>
            <div className="info-card-content">
                <p><strong>Project:</strong> {userData?.domain || "No domain assigned"}</p>
                <p><strong>Plan:</strong> {userData?.hosting || "N/A"}</p>
            </div>
          </div>

          {/* 4. User Data Card - UPDATED TO HIDE URL */}
          <div className="stat-card user-details-card">
            <h3>User Details</h3>
            <div className="info-card-content">
                <p><strong>Email:</strong> {userData?.email}</p>
                
                {/* --- CHANGED THIS PART --- */}
                <p><strong>Portal Link:</strong></p>
                {userData?.url ? (
                    <a 
                        href={userData.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="url-login-btn"
                    >
                        Login Now
                    </a>
                ) : (
                    <span>N/A</span>
                )}
                {/* ------------------------- */}
            </div>
          </div>
        </section>
      </div>
      
    </div>
  );
};

export default UserDashboard;